export default __webpack_public_path__ + "static/media/icons8-innovation-100.63f528b5.svg";